<template>
  <div
    v-loading="isLoading"
    ref="teldCommentRef"
    class="teld-comment w-full h-full teld-color-black flex flex-col relative text-sm"
  >
    <div
      v-if="showCommentTitle"
      class="comment-header px-5 py-4 flex justify-between items-center text-base"
    >
      <!-- 评论标题 -->
      <div
        :title="commentTitle"
        class="comment-header__title flex-1 mr-3 overflow-hidden text-ellipsis"
        style="--line-clamp:2"
      >
        评论数据：{{ commentTitle }}
      </div>
      <div class="comment-header__count teld-color-gray text-sm">
        {{ totalCommentCount }} 条评论
      </div>
    </div>
    <!-- 评论内容滚动区域 -->
    <div ref="commentScrollAreaRef" class="flex-1 overflow-y-auto">
      <div
        v-for="comment in commentList"
        :key="comment.ID"
        class="
          section-comment-with-replies flex px-5 py-3
          border-b border-solid border-gray-100
        "
      >
        <!-- 左侧头像 -->
        <div class="left-avatar mr-2" style="">
          <UserAvatar :image-url="comment.UserAvatar" />
        </div>

        <!-- 右侧内容 -->
        <CommentItem
          :data-item="comment"
          @increase="totalCommentCount += 1"
          @decrease="n => totalCommentCount -= (n || 1)"
        />
      </div>
      
      <template v-if="!isLoading && !commentList.length">
        <template v-if="$slots && $slots.empty">
          <slot name="empty"></slot>
        </template>
        <div v-else class="teld-comment--empty">
          <div class="teld-color-gray flex justify-center items-center h-20">
            {{ $commentOptions.emptyText || `暂无数据` }}
          </div>
        </div>
      </template>
    </div>

    <!-- 评论输入框 -->
    <draft-editor
      ref="draftEditorRef"
      :visible="!isLoading && visible"
      :show-avatar="false"
      :input-indicator="true"
      :is-comment="true"
      :auto-clear-on-hidding="true"
      class=""
      @comment="onComment"
    />
  </div>
</template>

<script>
// Commponents
import DraftEditor from "./draft-editor/index.vue";
import CommentItem from "./comment-item/index.vue";
import UserAvatar from "../user-avatar.vue";

// Utils
import { funcComments, dataComments } from "../../mock/commentData.js";
import loginUser from "../mixins/loginUser.js";
import { scrollPaging } from '../../core';

import '../assets/vant-override.css';
import '../assets/style-mobile.scss';

export default {
  name: "TmComment",
  inject: ['pageUrl', 'notificationLink'],
  props: {
    pageId: {
      type: String,
      default: "",
    },
    dataId: {
      type: String,
      default: "",
    },
    /**
     * 维度
     */
    dimension: {
      type: String,
      default: "",
    },
    commentType: {
      type: Number,
      default: 0,
    },
    commentTitle: {
      type: String,
      default: "",
    },
    showCommentTitle: {
      type: Boolean,
      default: false,
    },
    commentReference: {
      type: String,
      default: '',
    },
    showCommentReference: {
      type: Boolean,
      default: false,
    },
    /**透传visible用于点开时给editor赋焦点*/
    visible: {
      type: Boolean,
      default: false,
    }
  },
  provide() {
    return {
      showCommentReference: this.showCommentReference,
    }
  },
  components: {
    DraftEditor,
    CommentItem,
    UserAvatar,
  },
  mixins: [loginUser],
  data() {
    return {
      commentList: [],
      totalCommentCount: 0,
      isLoading: true,
      hasLoadedAll: false,
      pageIndex: 1,
      pageSize: 20,
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.init();
      } else {
        this.reset();
      }
    },
  },
  created() {
    this.init();
  },
  mounted() {
    const scrollArea = this.$refs.commentScrollAreaRef;
    if (scrollArea) {
      scrollArea.addEventListener('wheel', this.onScroll, true);
    }
  },
  beforeDestroy() {
    const scrollArea = this.$refs.commentScrollAreaRef;
    scrollArea && scrollArea.removeEventListener('wheel', this.onScroll);
  },
  methods: {
    async fetchPageData() {
      this.isLoading = true;
      try {
        const payload = {
          PageID: this.pageId,
          DataID: this.dataId,
          // DataName: this.commentTitle,
          Dimension: this.dimension,
          PageIndex: this.pageIndex,
          PageCount: this.pageSize,
          Sort: 0, // 评论-倒序
        }
        const { data } = await this.$utils.sgApi.getDataAsync({
          url: this.$utils.common.getServiceUrl('CMTS-GetCommentsByPageID'),
          data: { filter: JSON.stringify(payload)}
        }) || {};

        if (!data || data.state !== '1' || !data.data) {
          // 获取数据失败
          return;
        }

        // 成功获取数据后
        const { Items, TotalCount, Properties } = data.data;
        this.commentList = this.commentList.concat(Items);
        this.totalCommentCount = Properties && Properties.UICount || TotalCount;
        this.pageIndex += 1;
        this.hasLoadedAll = this.commentList.length >= TotalCount;
      } catch (error) {
        console.log(error);
      } finally {
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
      }
    },
    init() {
      if (this.pageId) {
        // Mock data for UI development
        // if (this.dataId) {
        //   this.commentList = [...dataComments];
        // } else {
        //   this.commentList = [...funcComments];
        // }
        // this.commentList = [...funcComments]; // 其实数据展示就不分什么的评论了都一样
        // this.totalCommentCount = this.commentList.length;
        // setTimeout(() => {
        //   this.isLoading = false;
        // }, 500);

        this.fetchPageData();
      }
      console.log("commentList", this.commentList);
    },
    reset() {
      this.commentList = [];
      this.totalCommentCount = 0;
      this.pageIndex = 1;
      const container = this.$refs.commentScrollAreaRef;
      if (container) {
        container.scrollTop = 0;
      }
    },
    async onComment(draftInfo) {
      const { content, fileList, onSucceed } = draftInfo;

      const newComment = {
        // IsAuthor: true,
        // 接口需要的参数：
        Content: content,
        Dimension: this.dimension, //
        PageID: this.pageId,
        DataID: this.dataId,
        DataName: this.commentTitle,
        ReferenceTitle: this.commentReference,
        CommentType: this.commentType,
        CommentCategory: 0,
        Attachments: fileList.map(n => n.result),
        UserAvatar: this.loginUserInfo.avatar,
        Url: this.notificationLink(),
        UrlParams: JSON.stringify({
          fpath: encodeURIComponent(this.pageUrl),
          showComment: true
        }),
      }

      try {
        const url = this.$utils.common.getServiceUrl("CMTS-SaveComment");
        const { data } = await this.$utils.sgApi.getDataAsync({
          url,
          method: "POST",
          data: {comment: JSON.stringify(newComment)},
        }) || {};
        console.log('SaveComment', data)

        if (data.state !== '1' || !data.data) {
          this.$TM.Toast('发送失败');
          return;
        }
        this.$TM.Toast('发送成功');

        // TODO 接口没有返回新数据对象，暂时用前端数据
        Object.assign(newComment, {
          ID: 'comment-m-' + parseInt(Math.random() * 1000), // TODO UI-mock
          CommentTime: Date().toLocaleString(), // TODO UI-mock
          UserID: this.loginUserInfo.userId, // TODO UI-mock
          UserName: this.loginUserInfo.userName, // TODO UI-mock
          Liked: false, // TODO UI-mock
          LikeCount: 0, // TODO UI-mock
          IsFavorite: false, // TODO UI-mock
          FavoriteCount: 0, // TODO UI-mock
          ReplyCount: 0, // TODO UI-mock
          CanRevoke: true, // TODO UI-mock
          IsDeleted: false, // TODO UI-mock
          Replies: [], // TODO UI-mock
        });

        // 评论完将新添加评论展示出来：滚动到顶部
        this.commentList.unshift((data && data.data) || newComment);
        const container = this.$refs.commentScrollAreaRef;
        container.scrollTop = 0;

        this.totalCommentCount += 1;

        setTimeout(() => {
          // 调接口成功后清空输入框内容
          onSucceed();
        }, 400);
      } catch (error) {
        console.log(error);
      }
    },
    onScroll(e) {
      const { deltaY } = e;
      if (deltaY < 0 || !this.commentList || !this.commentList.length || this.isLoading || this.hasLoadedAll) {
        // 滚向顶部时、没有数据时、正在加载数据时、及全部加载完时，滚动无需处理
        return;
      }
      requestAnimationFrame(this.scrollHanlder);
    },
    scrollHanlder() {
      const container = this.$refs.commentScrollAreaRef;
      const lastItem = container.querySelector('.section-comment-with-replies:last-child');
      // 提前 300px 获取下一页数据
      scrollPaging(container, lastItem, 300, this.fetchPageData);
    },
  },
};
</script>

<style lang="scss" scoped>
.teld-comment {
  .comment-header {
    .comment-header__title {
      display: -webkit-box;
      -webkit-line-clamp: var(--line-clamp);
      -webkit-box-orient: vertical;
    }
  }

  .section-comment-with-replies:last-child {
    border-bottom: none;
  }
}
</style>
